import {QueryReturnValue} from "@reduxjs/toolkit/dist/query/baseQueryTypes";

import {IModularHousesPublicListOffer, ModularHouseOfferHouseType, mpPublicApiLinks} from "@pg-mono/rp-api-routes";

import {mpApi} from "../../app/api/mp_api";
import {IOffsetLimitResponse} from "../../request/ILimitOffsetResponse";
import {IRpStoreFetchBaseQueryError} from "../../store/types/IRpStoreFetchBaseQueryError";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IGetModularHouseOfferPayload} from "../types/IGetModularHouseOfferPayload";

export const getModularHousesOfferListApi = mpApi.injectEndpoints({
    endpoints: (builder) => ({
        getModularHouseOfferList: builder.query<IOffsetLimitResponse<IModularHousesPublicListOffer>, IGetModularHouseOfferPayload & {type?: number}>({
            queryFn: async (arg, _api, _extraOptions, baseQuery) => {
                const isBadHouseType = arg.house_type && !Object.values(ModularHouseOfferHouseType).some((val) => val == arg.house_type);

                if (isBadHouseType) {
                    return {
                        error: {
                            status: "CUSTOM_ERROR",
                            error: "Invalid house type",
                            ignoreNotify: true
                        }
                    };
                }

                const query = await baseQuery({
                    url: mpPublicApiLinks.marketplace.modularHouses.offer.list(),
                    method: "GET",
                    params: arg
                });

                if (query.error) {
                    return {
                        ...query,
                        error: getIgnoredNotifyResponse(query.error, [404])
                    };
                }

                return query as QueryReturnValue<IOffsetLimitResponse<IModularHousesPublicListOffer>, IRpStoreFetchBaseQueryError, {}>;
            },

            providesTags: (result) => {
                if (result) {
                    return [...result.results.map((offer) => ({type: "ModularHouseOffer" as const, id: offer.id})), "ModularHouseOffer"];
                }

                return ["ModularHouseOffer"];
            }
        })
    })
});

export const {useLazyGetModularHouseOfferListQuery, useGetModularHouseOfferListQuery} = getModularHousesOfferListApi;
import {QueryReturnValue} from "@reduxjs/toolkit/dist/query/baseQueryTypes";

import {IModularHousesPublicListOffer, ModularHouseOfferHouseType, mpPublicApiLinks} from "@pg-mono/rp-api-routes";

import {mpApi} from "../../app/api/mp_api";
import {IOffsetLimitResponse} from "../../request/ILimitOffsetResponse";
import {IRpStoreFetchBaseQueryError} from "../../store/types/IRpStoreFetchBaseQueryError";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IGetModularHouseOfferPayload} from "../types/IGetModularHouseOfferPayload";

export const getModularHousesOfferListApi = mpApi.injectEndpoints({
    endpoints: (builder) => ({
        getModularHouseOfferList: builder.query<IOffsetLimitResponse<IModularHousesPublicListOffer>, IGetModularHouseOfferPayload & {type?: number}>({
            queryFn: async (arg, _api, _extraOptions, baseQuery) => {
                const isBadHouseType = arg.house_type && !Object.values(ModularHouseOfferHouseType).some((val) => val == arg.house_type);

                if (isBadHouseType) {
                    return {
                        error: {
                            status: "CUSTOM_ERROR",
                            error: "Invalid house type",
                            ignoreNotify: true
                        }
                    };
                }

                const query = await baseQuery({
                    url: mpPublicApiLinks.marketplace.modularHouses.offer.list(),
                    method: "GET",
                    params: arg
                });

                if (query.error) {
                    return {
                        ...query,
                        error: getIgnoredNotifyResponse(query.error, [404])
                    };
                }

                return query as QueryReturnValue<IOffsetLimitResponse<IModularHousesPublicListOffer>, IRpStoreFetchBaseQueryError, {}>;
            },

            providesTags: (result) => {
                if (result) {
                    return [...result.results.map((offer) => ({type: "ModularHouseOffer" as const, id: offer.id})), "ModularHouseOffer"];
                }

                return ["ModularHouseOffer"];
            }
        })
    })
});

export const {useLazyGetModularHouseOfferListQuery, useGetModularHouseOfferListQuery} = getModularHousesOfferListApi;
